/* eslint-disable internal-rules/no-hardcoded-colors */
// These are dynamic color palette definitions that get applied as CSS custom properties
export const CUSTOM_STATUS_COLORS = Object.freeze({
    '#028CC2': {
        activeBackground: 'var(--status-color-map-blue-pressed)',
        background: 'var(--status-color-map-blue-background)',
        textColor: 'var(--text-body-default-base)',
        dotColor: 'var(--status-color-map-blue-primary)',
    },
    '#5AB7CF': {
        activeBackground: 'var(--status-color-map-teal-pressed)',
        background: 'var(--status-color-map-teal-background)',
        textColor: 'var(--text-body-default-base)',
        dotColor: 'var(--status-color-map-teal-primary)',
    },
    '#9440EE': {
        activeBackground: 'var(--status-color-map-purple-pressed)',
        background: 'var(--status-color-map-purple-background)',
        textColor: 'var(--text-body-default-base)',
        dotColor: 'var(--status-color-map-purple-primary)',
    },
    '#FF7107': {
        activeBackground: 'var(--status-color-map-orange-pressed)',
        background: 'var(--status-color-map-orange-background)',
        textColor: 'var(--text-body-default-base)',
        dotColor: 'var(--status-color-map-orange-primary)',
    },
    '#009855': {
        activeBackground: 'var(--status-color-map-green-pressed)',
        background: 'var(--status-color-map-green-background)',
        textColor: 'var(--text-body-default-base)',
        dotColor: 'var(--status-color-map-green-primary)',
    },
    '#6A6C75': {
        activeBackground: 'var(--status-color-map-gray-pressed)',
        background: 'var(--status-color-map-gray-background)',
        textColor: 'var(--text-body-default-base)',
        dotColor: 'var(--status-color-map-gray-primary)',
    },
    '#DBA211': {
        activeBackground: 'var(--status-color-map-yellow-pressed)',
        background: 'var(--status-color-map-yellow-background)',
        textColor: 'var(--text-body-default-base)',
        dotColor: 'var(--status-color-map-yellow-primary)',
    },
    '#D035C1': {
        activeBackground: 'var(--status-color-map-magenta-pressed)',
        background: 'var(--status-color-map-magenta-background)',
        textColor: 'var(--text-body-default-base)',
        dotColor: 'var(--status-color-map-magenta-primary)',
    },
    '#CC0000': {
        activeBackground: 'var(--status-color-map-red-pressed)',
        background: 'var(--status-color-map-red-background)',
        textColor: 'var(--text-body-default-base)',
        dotColor: 'var(--status-color-map-red-primary)',
    },
});
